import { useEffect, useState } from 'react';
import { Icon } from './Icons.jsx';
import { cancelOrder } from '../api/orders.js';

// Confirmação de senha pra cancelar um pedido — backend garante a regra de
// negócio (prazo de 7 dias, status elegível, senha correta); este modal só
// coleta a senha e mostra os erros que a API devolver.
export default function ConfirmCancelOrderModal({ order, onClose, onCancelled }) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape' && !submitting) onClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose, submitting]);

  const submit = async (e) => {
    e.preventDefault();
    if (!password || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const updated = await cancelOrder(order.id, password);
      onCancelled(updated);
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Não foi possível cancelar o pedido.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300 }}>
      <div onClick={() => !submitting && onClose()} style={{ position: 'absolute', inset: 0, background: 'var(--overlay-navy-45)' }}/>
      <div className="bottom-sheet" style={{
        background: 'var(--white)', borderRadius: '20px 20px 0 0', boxShadow: '0 -20px 50px var(--overlay-navy-25)',
        padding: '18px 18px 28px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 16, color: 'var(--midnight)', flex: 1 }}>
            Cancelar pedido {order.protocol_number || ''}
          </div>
          <button onClick={() => !submitting && onClose()} aria-label="Fechar" style={{ color: 'var(--text-muted)', padding: 4 }}>
            <Icon.x size={22}/>
          </button>
        </div>

        <p style={{ marginTop: 10, fontSize: 13.5, lineHeight: 1.55, color: 'var(--text-muted)' }}>
          O cancelamento só é permitido em até 7 dias após a data do pedido.
          Ao confirmar, você receberá um aviso de cancelamento e, assim que o
          estorno for concluído junto ao meio de pagamento usado na compra,
          um novo aviso de confirmação do reembolso.
        </p>

        <form onSubmit={submit} style={{ marginTop: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <label className="input-label" htmlFor="cancel-order-password">Confirme sua senha para continuar</label>
          <div style={{ position: 'relative' }}>
            <input
              id="cancel-order-password"
              className="input"
              type={showPassword ? 'text' : 'password'}
              placeholder="Sua senha"
              autoComplete="current-password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ paddingRight: 48 }}
            />
            <button
              type="button"
              aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              onClick={() => setShowPassword((s) => !s)}
              style={{ position: 'absolute', right: 10, top: 13, padding: 6, color: 'var(--text-muted)' }}
            >
              {showPassword ? <Icon.eyeOff size={20}/> : <Icon.eye size={20}/>}
            </button>
          </div>

          {error && (
            <div role="alert" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: 'var(--danger-tint)', borderRadius: 10, color: 'var(--danger-strong)', fontSize: 13 }}>
              <Icon.info size={16} color="var(--danger-strong)"/>
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary" disabled={!password || submitting} style={{ marginTop: 4, background: 'var(--danger)' }}>
            {submitting ? 'Cancelando…' : 'Confirmar cancelamento'}
          </button>
          <button type="button" className="btn btn-outline" onClick={() => !submitting && onClose()} disabled={submitting}>
            Voltar
          </button>
        </form>
      </div>
    </div>
  );
}
